import moment from 'moment';
import { DATE_FORMATS } from 'utils/helpers'

export const KEYPAD_ROWS = [
  ['1', '2', '3'],
  ['4', '5', '6'],
  ['7', '8', '9'],
  ['clear', '0', 'backspace'],
];

export const applyConvenienceFee = (amount, percentage) =>
  parseFloat((amount + (amount / 100) * percentage).toFixed(2));

export const removeConvenienceFee = (amount, percentage) =>
  parseFloat(((amount * 100) / (100 + percentage)).toFixed(2));

export const getChargePayload = (without_fee, amount, percentage) => ({
  charge: {
    amount: without_fee ? amount : removeConvenienceFee(amount, percentage),
    date: moment().format(DATE_FORMATS.iso),
    payments_attributes: [{ amount }],
  },
});

export const handleBackSpace = (preValue) => {
  let withoutDecimalNum = preValue.replace('.', '');
  withoutDecimalNum = withoutDecimalNum.slice(0, -1);

  if (withoutDecimalNum === '') withoutDecimalNum = '0';

  const withDecimalNum = parseInt(withoutDecimalNum, 10) / 100;

  return withDecimalNum.toFixed(2)
}

export const addNewDigitIntoValue = (preValue, newDigit) => {
  let withoutDecimalNum = preValue.replace('.', '');
  withoutDecimalNum += newDigit;
  let withDecimalNum = parseInt(withoutDecimalNum, 10) / 100;
  return withDecimalNum.toFixed(2)
}

export const getDigitsFontSize = (length: number) => {
  if (length >= 20) return 'text-2xl';
  if (length >= 14) return 'text-3xl';
  if (length >= 12) return 'text-4xl';
  if (length >= 9) return 'text-5xl';
  return 'text-6xl';
};

export const dollarSignClass = (length: number) => {
  if (length >= 14) return 'text-sm';
  if (length >= 12) return 'text-xl';
  if (length >= 9) return 'text-2xl mb-0.5';
  return 'text-3xl mb-1';
};
